import React from 'react';
import PropTypes from 'prop-types';

import '../../style.scss';

const ModalFooter = ({ children, justifyContent, className }) => (
  <footer
    styleName="modal__footer"
    style={{ justifyContent }}
    className={className}
    data-test="modal-footer"
  >
    {children}
  </footer>
);

ModalFooter.propTypes = {
  children: PropTypes.node,
  justifyContent: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'space-evenly',
  ]),
  className: PropTypes.string,
};

ModalFooter.defaultProps = {
  children: null,
  justifyContent: 'flex-start',
  className: '',
};

export default ModalFooter;
